import { render, staticRenderFns } from "./TreatmentHistory.vue?vue&type=template&id=047967df&scoped=true&"
import script from "./TreatmentHistory.vue?vue&type=script&lang=js&"
export * from "./TreatmentHistory.vue?vue&type=script&lang=js&"
import style0 from "./TreatmentHistory.vue?vue&type=style&index=0&id=047967df&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047967df",
  null
  
)

export default component.exports